import { WizModal } from "wiz-components";

/**
 * @author PengWen
 * @description 新能源组织迁移  业务数据的受众/管理范围调整
 * @Date 2023/03/20
 */
let componentName = "bizDataMoveRecord"

const columns = [
    {
        name: "id",
        fromItem: {
            type: "hidden"
        }
    },
    {
        title: "权限类型",
        name: "permType",
        searchItem: {
            type: "select",
        },
        dict: [
            {code:1,codeName:'受众范围'},
            {code:0,codeName:'管理范围'},
        ]
    },
    {
        title: "权限类型",
        name: "permTypeString",
        tableItem: {
            width: 200
        },
    },
    {
        title: "操作类型",
        name: "operationType",
        searchItem: {
            type: "select",
        },
        dict: [
            {code:1,codeName:'新增'},
            {code:2,codeName:'替换'},
            {code:3,codeName:'删除'},
            {code:4,codeName:'回滚'},
        ]
    },
    {
        title: "操作类型",
        name: "operationTypeString",
        tableItem: {
            width: 200
        },
    },
    {
        title: "受影响的业务ids",
        name: "entityIds",
        tableItem: {
            width: 500
        },
    },
    {
        title: "操作时间",
        name: "createTime",
        tableItem: {
            
        },
    },
    
];

const templateConfig = {
    mainProps: {},
    content: {
        name: 'WizTableList',
        params: {
            columns,
            searchBarProps: {
                buttonSort: [],
                collapse: false,
                buttons: []
            },
            modalFormProps: {},
            dataTableProps: {
                rowKey: 'id',
                //selectType: 'checkbox',
                isScroll: true,
                bordered: false,
                paging: false,
                loading: false
            },
            rowOperateSort: ['rollBack'],
            rowOperateView: [
                {
                    key: 'rollBack',
                    custom: true,
                    params: { children: "操作回滚"},
                    customOnClick: {
                        key: 'action',
                        params: {
                            apiKey: 'rollBack',
                        },
                        formatParams: (rows, record, filters, callback) => {
                            const content = `您确定要回滚该操作记录吗？`;
                            WizModal.confirm({
                                title: '注意',content,
                                onOk: () => {
                                    callback && callback({
                                        id: record['id'],
                                    })
                                },
                                onCancel() {

                                }
                            });
                            return null
                        }
                    }
                }
            ],
            rowOperateProps: {
                width: 200,
                fixed: 'right',
            },
        }
    }
}

let reduxTemplateConfig = (args) => {
    const { record } = args;
    const { id } = record; 
    const apis = {
        list: {
          path: `${componentName}/bizDataRecordPageList`,
          payload: {
            key: `${componentName}@bizDataRecordPageList`,
            apiParams: {businessId : id}
          }
        },
        rollBack: {
            path: `${componentName}/rollBack`,
            payload: {
                key: `${componentName}@rollBack`,
                apiParams: {}
              }
        },
    }

    return {
        apis,
        componentName,
        initApiKeys: ['list'],
        needLoading: true,
        keepInitApiParams: true,
        ...args
      }
}

export {reduxTemplateConfig, templateConfig};